import { BorderGridContainer, GridBox, SpacerWrapper, Spinner } from '@ahmdigital/ui';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { INSURANCE_TYPES } from '../../../src/client/pages/insurance/constants';
import constants from '../../../src/client/ahm-constants';
import getInsuranceTypeFromLocation from '../../../src/client/pages/insurance/utils/get-insurance-type-from-location';
import getStaticPathsForInsuranceTypes from '../utils/get-static-paths-for-insurance-types';
import Head from '../../../src/utils/head';
import launchOpenQuoteForm from '../../../src/client/application/scripts/open';
import type { InsuranceTypeParamValue } from '../../../src/client/pages/insurance/types';

export const getStaticPaths = () => getStaticPathsForInsuranceTypes([INSURANCE_TYPES.CAR, INSURANCE_TYPES.HOME]);

export const getStaticProps = ({ params: { insuranceType } }: { params: { insuranceType: string } }) => ({
  props: { location: insuranceType },
});

const insuranceTypeMetadata: Partial<Record<InsuranceTypeParamValue, { title: string; description?: string }>> = {
  'car-insurance': { title: 'Get a quote for car insurance' },
  'home-insurance': { title: 'Get a quote for home and contents insurance' },
};

type Props = {
  location: InsuranceTypeParamValue;
};

const InsuranceQuotePage = ({ location }: Props) => {
  const router = useRouter();
  const insuranceType = getInsuranceTypeFromLocation(location);
  const metadata = insuranceTypeMetadata[location];

  useEffect(() => {
    const launched = launchOpenQuoteForm({ inNewTab: false, productSlug: insuranceType });

    setTimeout(() => {
      if (!launched) {
        router.replace(constants.URLS.SALES.ERROR_404);
      }
    }, 10000); // 10 Seconds to account for slow connections
  });

  return (
    <>
      {metadata && (
        <Head titleTemplate="%s - ahm insurance">
          <title>{metadata.title}</title>
          {metadata.description && <meta name="description" content={metadata.description} />}
        </Head>
      )}
      <BorderGridContainer hideBorderTop>
        <GridBox padding="1rem">
          <SpacerWrapper variant={['marginBottomSpacer2', 'marginTopSpacer2']}>
            <Spinner />
          </SpacerWrapper>
        </GridBox>
      </BorderGridContainer>
    </>
  );
};

export default InsuranceQuotePage;
